import React from "react";

function App() {
  return (
    <div>
      <a href="proactive.crx">sample-extension.crx</a>
    </div>
  );
}

export default App;
